// extracted by mini-css-extract-plugin
export default {"HeroContainer":"HeroSection_HeroContainer__yv8OY","ContentContainer":"HeroSection_ContentContainer__7klGo","Title":"HeroSection_Title__zYqbw","Text":"HeroSection_Text__lSWdX"};